module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAmCAMAAAAcJyCnAAAAbFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8+T+BWAAAAI3RSTlMAlqURMwUx+Tns44uDaklDoI4sD/Ta1cfAtqGFdj0kCwiikrtqGuYAAAC8SURBVCjPzdNZDoIwFIXhI9JBJgEnZtCz/z0qNEBrugD+xy9Nmt7cYu5sB5O80O6SmZO1o6r82fV5RXq3tBNBj5gspuG1YSUSFjiRjAEZmqTQiqdFA+yND3o0oU+DA+jbqzJatYHVLTeqNJyyEDpi65hIz/PQU+Foy0gjzOCklbktv9na0Cij0vuK/GCT3DXx6WP0qNJi2ycgXrRgIiquvYbpM+9dH4iOe/d02V2gVLSrzQizvx8gAf9v+QKUxCcHOLjt1AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/progressPage/num-0.png
// module id = NJZ4
// module chunks = 1